export type Status = 'Pending' | 'Active' | 'Block';


export enum RoleEnum {
  Admin = 1,
  ProjectManager = 2,
  SaleManager = 3,
  SaleLead = 4,
  SaleStaff = 5,
  DigitalSupervisor = 6,
  DigitalLeader = 7,
  DigitalStaff = 8,
  Telesale = 9,
  SaleTrucPage = 11,
  BOD = 12,
  CEO = 13,
  ProjectSub = 14,
  SaleSub = 15,
  SeniorLead = 16,
  SaleSeniorLead = 17,
  QC=18
}
